/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';

export const useAttributesMatrix = (props) => {
  useEffect(() => {
    if (!props.attributesMatrix.fetched && !props.attributesMatrix.fetching) {
      props.fetchListAttributesMatrix();
    }
  }, []);
};

export default useAttributesMatrix;
